/* eslint-disable react/display-name */
import { useCallback } from 'react';
import { Dropdown } from '@/components/Dropdown';
import type { ButtonRenderProps } from '@/components/Dropdown';
import type { Props as DropdownProps } from '../Dropdown/Dropdown';
import { Button } from '@simplywallst/ui-core';
import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';

export const MinimalDropdown = ({ label, ...props }: DropdownProps) => {
  const dropdownButton = useCallback(
    (label) =>
      ({ onBlur, onFocus, onClick, innerRef, name }: ButtonRenderProps) => {
        return (
          <Button
            styleType="gentle"
            alignIcon="right"
            onBlur={onBlur}
            onFocus={onFocus}
            onClick={onClick}
            ref={innerRef}
            data-cy-id={name}
          >
            <span data-cy-id={`${name}-text`}>{label}</span>
            <ChevronDownSmallSolid />
          </Button>
        );
      },
    []
  );
  return <Dropdown {...props} isMinimal buttonRender={dropdownButton(label)} />;
};
